import { render, staticRenderFns } from "./StockMovements.html?vue&type=template&id=d70f8182&scoped=true&external"
import script from "./StockMovements.js?vue&type=script&lang=js&external"
export * from "./StockMovements.js?vue&type=script&lang=js&external"
import style0 from "./StockMovements.vue?vue&type=style&index=0&id=d70f8182&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70f8182",
  null
  
)

export default component.exports